import styled, { css } from 'styled-components';
import { colors } from '../../../base/styled/variables.styled';
import { typography, media } from '../../../base/styled/typography.style';
// Função auxiliar para aplicar estilos de tipografia
// Recebe uma chave de tipografia (ex: 'body1') e aplica os estilos base e responsivos.
const applyTypography = (type) => {
    const typo = typography[type];
    const tabletTypo = typo[media.tablet];
    const desktopTypo = typo[media.desktop];
    return css `
  font-family: ${typo.fontFamily};
  font-weight: ${typo.fontWeight};
  font-size: ${typo.fontSize};
  line-height: ${typo.lineHeight};
  ${typo.fontStyle && `font-style: ${typo.fontStyle};`}
  ${typo.textTransform && `text-transform: ${typo.textTransform};`}
  ${typo.textDecoration && `text-decoration: ${typo.textDecoration};`}


  ${media.tablet} {
    ${tabletTypo && css `
      font-size: ${tabletTypo.fontSize};
      line-height: ${tabletTypo.lineHeight};
    `}
  }

  ${media.desktop} {
    ${desktopTypo && css `
      font-size: ${desktopTypo.fontSize};
      line-height: ${desktopTypo.lineHeight};
    `}
  }
`;
};
export const TagContainer = styled.div `
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 0;
  width: auto;
  border: 2px solid ${colors.brand200};
  border-radius: 8px;
  margin-right: 8px;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${colors.brand75};
  }

  &:focus-visible {
    border: 3px solid ${colors.brand200};
    box-shadow: 0 0 0 3px ${colors.brand300};
  }
`;
export const ContentContainer = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  gap: 8px;
  border-radius: 8px;

  ${media.tablet} {
    padding: 8px 16px;
  }

  ${media.desktop} {
    padding: 8px 16px;
  }
`;
export const Content = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  gap: 4px;
  width: auto;

  ${media.tablet} {
    gap: 6px;
  }

  ${media.desktop} {
    gap: 8px;
  }
`;
export const TagText = styled.span `
  ${applyTypography('body1')}
  color: ${({ inverse }) => inverse ? colors.neutral200 : colors.brand500};

  display: flex;
  align-items: center;
  width: auto;
  height: 24px;
  white-space: nowrap;
`;
export const RemoveIcon = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse'].includes(prop),
}) `
  box-sizing: content-box;
  width: 16px;
  height: 16px;
  color: ${({ inverse }) => inverse ? colors.neutral200 : colors.brand500};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;

  padding: 12px 15px;
  margin: -12px -15px;

  &:focus-visible {
    outline: 2px solid ${colors.brand100};
    border-radius: 50%;
  }

  ${media.tablet} {
    width: 16px;
    height: 16px;
  }

  ${media.desktop} {
    width: 16px;
    height: 16px;
  }
`;
//# sourceMappingURL=FilterTag.style.js.map